// 命名格式 auth_name 格式   auth 是对应父级的数据
const menuList = [
  {
    title: "用户列表",
    path: "user",
    auth: "USER",
    icon: "icon-user",
    children: [
      {
        title: "用户列表",
        path: "user_list",
        auth: "USER_LIST",
      },
    ],
  },
  {
    title: "设备列表",
    path: "equipment",
    auth: "EQUIPMENT",
    icon: "icon-shebei",
    children: [
      {
        title: "设备列表",
        path: "equipment_list",
        auth: "EQUIPMENT_LIST",
      },
      // {
      //   title: "ncc设备管理列表",
      //   path: "ncc_equipment_list",
      //   auth: "NCC_EQUIPMENT_LIST"
      // }
      // {
      //   title: "导入设备",
      //   path: "equipment_import",
      //   auth: "EQUIPMENT_IMPORT"
      // }
    ],
  },
  {
    title: "固件版本管理",
    path: "FirmwareVersion",
    auth: "FIRMWAREVERSION",
    icon: "icon-banben",
    children: [
      {
        title: "研发固件版本列表",
        path: "FirmwareVersion_list",
        auth: "FIRMWAREVERSION_LIST",
      },
      {
        title: "工厂固件版本列表",
        path: "FirmwareVersion_list_Plant",
        auth: "FIRMWAREVERSION_LIST_PLANT",
      },
    ],
  },
  {
    title: "其他管理",
    path: "Other",
    auth: "OTHER",
    icon: "icon-qita",
    children: [
      {
        title: "设备类型管理",
        path: "DeviceTypeManagement",
        auth: "OTHER_DEVICETYPEMANAGEMENT",
      },
      {
        title: "设备提示",
        path: "EquipmentTips",
        auth: "OTHER_EquipmentTips",
      },
      {
        title: "意见反馈",
        path: "feedback_list",
        auth: "OTHER_FEEDBACK_LIST",
      },
      {
        title: "应用版反馈",
        path: "app_feedback_list",
        auth: "OTHER_APP_FEEDBACK_LIST",
      },
      // {
      //   title: "教程详情",
      //   path: "official_details",
      //   auth: "OTHER_OFFICIAL_DETAILS"
      // },
      {
        title: "职业管理",
        path: "profess_list",
        auth: "OTHER_PROFESS_LIST",
      },
      {
        title: "matter 二维码管理",
        path: "matter-admin",
        auth: "MATTER_ADMIN",
      },
    ],
  },
  {
    title: "NCC管理",
    path: "ncc",
    auth: "ncc",
    icon: "icon-shezhi",
    children: [
      {
        title: "设备添加指引",
        path: "ncc",
        auth: "SYSTEM_NCC_LIST",
      },
      {
        title: "ncc版本管理",
        path: "ncc_version",
        auth: "SYSTEM_NCC_VERSION",
      },
    ],
  },
  {
    title: "系统管理",
    path: "system",
    auth: "SYSTEM",
    icon: "icon-shezhi",
    children: [
      {
        title: "系统管理员",
        path: "administrator_list",
        auth: "SYSTEM_ADMINISTRATOR_LIST",
      },
      {
        title: "角色管理",
        path: "role_list",
        auth: "SYSTEM_ROLE_LIST",
      },
      {
        title: "APP更新",
        path: "systemUpdate",
        auth: "SYSTEM_SYSTEMUPDATE",
      },
      {
        title: "操作日志",
        path: "log_list",
        auth: "SYSTEM_LOG_LIST",
      },
      // {
      //   title: "职业管理",
      //   path: "profess_list",
      //   auth: "PROFESS_LIST",
      // },
    ],
  },
  {
    title: "统计分析",
    path: "statistic",
    auth: "STATISTIC",
    icon: "icon-tongji",
    children: [
      {
        title: "用户统计",
        path: "statistic_user",
        auth: "STATISTIC_USER",
      },
      {
        title: "设备统计",
        path: "statistic_equipment",
        auth: "STATISTIC_EQUIPMENT",
      },

      {
        title: "辅助工具统计",
        path: "statistic_auxiliaryMeans",
        auth: "STATISTIC_AUXILIARYMEANS",
      },
    ],
  },
  {
    title: "纽尔下载中心",
    path: "neewerdownload",
    auth: "NEEWERDOWNLOAD",
    icon: "icon-tongji",
    children: [
      {
        title: "固件管理",
        path: "firmware",
        auth: "NEEWERDOWNLOAD_FIRMWARE",
      },
      {
        title: "AI 版本管理",
        path: "neewerai",
        auth: "NEEWERDOWNLOAD_AI",
      },
      {
        title: "说明书管理",
        path: "instruction",
        auth: "NEEWERDOWNLOAD_INSTRUCTION",
      },
      {
        title: "FAQ管理",
        path: "faq",
        auth: "NEEWERDOWNLOAD_FAQ",
      },
      {
        title: "宣传册管理",
        path: "brochure",
        auth: "NEEWERDOWNLOAD_BROCHURE",
      },
      // ,
      // {
      //  title: "桌面应用管理",
      //  path: "app_pc_manage",
      //  auth: "NEEWERDOWNLOAD_APP"
      // }
      {
        title: "软件版本管理",
        path: "app_version",
        auth: "NEEWERDOWNLOAD_APP_VERSION",
      },
    ],
  },
  {
    title: "NEEWERHOME",
    path: "neewerhome",
    auth: "NEEWERHOME",
    icon: "icon-tongji",
    children: [
      {
        title: "设备注册",
        path: "deviceAuth",
        auth: "NEEWERHOME_AUTH",
      },
      {
        title: "指令日志",
        path: "mqtt_log",
        auth: "NEEWERHOME_LOG",
      },
      {
        title: "定时颜色固件版本",
        path: "timeColorVersion",
        auth: "NEEWERHOME_TIME_COLOR_VERSION",
      },
      {
        title: "场景特效八国语言翻译",
        path: "effectEightLang",
        auth: "NEEWERHOME_EFFECT_EIGHT_LANG",
      },
      {
        title: "DIY场景类别",
        path: "diyEffectType",
        auth: "NEEWERHOME_DIY_EFFECT_TYPE",
      },
      {
        title: "DIY场景名称",
        path: "diyEffectName",
        auth: "NEEWERHOME_DIY_EFFECT_NAME",
      },
      {
        title: "DIY场景特效",
        path: "diySceneEffect",
        auth: "NEEWERHOME_DIY_SCENE_EFFECT",
      },
      {
        title: "场景特效",
        path: "sceneEffect",
        auth: "NEEWERHOME_SCENE_EFFECT",
      },
      {
        title: "DIY设置",
        path: "diySetting",
        auth: "NEEWERHOME_DIY_SETTING",
      },
    ],
  },
  {
    title: "NEEWERVIEW",
    path: "neewerview",
    auth: "NEEWERVIEW",
    icon: "icon-tongji",
    children: [
      {
        title: "麦克风设备号管理",
        path: "audio_device_config",
        auth: "NEEWERVIEW_DEVICE_CONFIG",
      },
    ],
  },
];

export { menuList };
